import { LockKeyhole, ShieldCheck } from 'lucide-react'
import type { PropsWithChildren, ReactNode } from 'react'
import { BrandLogo, ThemeToggle } from '@/design-system'

export function AuthLayout({ children, aside }: PropsWithChildren<{ aside?: ReactNode }>) {
  return (
    <main className="auth-page">
      <section className="auth-page__brand" aria-label="Groupe RECA">
        <div className="auth-page__brand-top">
          <BrandLogo />
          <span>Centre de commandement</span>
        </div>
        <div className="auth-page__statement">
          <span className="auth-page__eyebrow">Opérations hivernales</span>
          <h1>Pilotez chaque tempête avec une vue claire du terrain.</h1>
          <p>Planification, supervision et finances réunies dans un environnement sécurisé.</p>
        </div>
        <div className="auth-page__trust">
          <ShieldCheck aria-hidden="true" />
          <span>
            <strong>Accès protégé</strong>
            <small>Permissions par organisation et journalisation des actions sensibles.</small>
          </span>
        </div>
      </section>
      <section className="auth-page__form-column">
        <div className="auth-page__toolbar">
          <LockKeyhole aria-hidden="true" />
          <span>Connexion sécurisée</span>
          <ThemeToggle />
        </div>
        <div className="auth-card">{children}</div>
        {aside}
        <p className="auth-page__legal">© 2026 Groupe RECA · Environnement sécurisé</p>
      </section>
    </main>
  )
}
